import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { goalService } from '../services/api';

const CreateGoal = () => {
  const [description, setDescription] = useState('');
  const [skillLevel, setSkillLevel] = useState('Beginner');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      // Create metadata with skill level
      const metadata = JSON.stringify({ level: skillLevel });
      
      // Create the goal with metadata
      const goal = await goalService.createGoal(description, metadata);
      navigate(`/roadmap`);
    } catch (err) {
      setError('Failed to create goal');
      setLoading(false);
      console.error(err);
    }
  };

  return (
    <div className="create-goal-container">
      <h2>Create a New Learning Goal</h2>
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="description">What do you want to learn?</label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="e.g., Learn Python for Data Science, Master Calculus, Prepare for History Exam"
            required
            rows={4}
          />
          <p className="form-hint">
            Be specific about what you want to learn. This will help us create a personalized learning plan for you.
          </p>
        </div>
        
        <div className="form-group">
          <label htmlFor="skillLevel">Desired Course Difficulty</label>
          <select
            id="skillLevel"
            value={skillLevel}
            onChange={(e) => setSkillLevel(e.target.value)}
            className="skill-level-dropdown"
          >
            <option value="Beginner">Beginner</option>
            <option value="Practitioner">Practitioner</option>
            <option value="Advanced">Advanced</option>
          </select>
          <p className="form-hint">
            Select the difficulty level that matches your current knowledge.
          </p>
        </div>
        
        <div className="form-actions">
          <button 
            type="button" 
            className="btn-secondary"
            onClick={() => navigate('/roadmap')}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="btn-primary"
            disabled={loading}
          >
            {loading ? 'Creating...' : 'Create Goal'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateGoal; 